import React, { useEffect } from 'react'
import s from './TopMenuProductCategory.module.scss'
import { ReactComponent as GoBackIcon } from 'images/new-icons/arrow-go-back.svg';

import { ReactComponent as Bag } from 'images/dark-green-cart.svg';
import { useNavigate } from 'react-router-dom';
import useIsAuth from 'sdk/hooks/useIsAuth';
import useGetOrdersInTheCart from 'sdk/hooks/shop/useGetOrdersInTheCart';
import ArrowSvgLang from 'modules/app/components/UI/ArrowSvgLang';

const TopMenuProductCategory = ({ onOpen }) => {
  const navigate = useNavigate()
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  const { data: cartItems, refetch: refetchCart } = useGetOrdersInTheCart(userId);

  useEffect(() => {
    refetchCart();
  }, [userId]);

  interface CartItem {
    count: number;
  }
  const itemCount = (cartItems as CartItem[] | undefined)?.reduce((total: number, item: CartItem) => total + (item.count || 0), 0) || 0;
  const displayCount: string | number = itemCount > 9 ? '9+' : itemCount;

 

  return (
    <div className={s.container}>
      <ArrowSvgLang className={s.container_notification_icon} onClick={() => navigate('/shop')} />
      <div className={s.container_right_icons}>
        <div className={s.cart_wrapper} onClick={() => onOpen(false)}>
          <Bag />
          {itemCount > 0 && <div className={s.counter}>{String(displayCount)}</div>}
        </div>
      </div>
    </div>
  )
}

export default TopMenuProductCategory